module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "adventure": _vm.adventure,
      "adventureId": _vm.adventureId,
      "chapter": _vm.chapter,
      "chapterId": _vm.chapterId,
      "timelineLocation": _vm.timelineLocation
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "background-color": "white",
      "margin-top": "20px"
    },
    attrs: {
      "id": "page-timeline"
    }
  }, [_c('div', {
    staticClass: "mdl-grid mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "mdl-cell--6-col mdl-cell--12-col-tablet"
  }, [_c('div', {
    staticClass: "mdl-cell--12-col",
    attrs: {
      "id": "timeline-view"
    }
  }, [_c('div', {
    staticClass: "timeline-container",
    attrs: {
      "id": "timeline-container"
    }
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": '/editor/' + _vm.adventureId + '/chapters/' + _vm.chapterId + '/timeline/' + _vm.getLocationParent()
    }
  }, [_c('div', {
    staticClass: "delimiter-node"
  }, [(_vm.getLocationName()) ? _c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "width": "14px, height: 14px",
      "position": "relative",
      "vertical-align": "middle"
    }
  }, [_vm._v("keyboard_arrow_left")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.getLocationName() || 'START'))])]), _vm._v(" "), _c('div', {
    staticClass: "arrow-down delimiter"
  })], 1), _vm._v(" "), _vm._l((_vm.eventGroupsForLocation(_vm.timelineLocation)), function(group, groupKey) {
    return _c('div', [_c('div', {
      staticClass: "group-node event-drop-area collapsed",
      attrs: {
        "name": group.key
      }
    }, [_c('div', {
      staticClass: "plus-button",
      on: {
        "click": function($event) {
          _vm.createEventAndGroup(group.key)
        }
      }
    }, [_vm._v("\n                  +\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "group-node"
    }, [_c('div', {
      staticClass: "arrow-up"
    }), _vm._v(" "), _c('div', {
      staticClass: "event-drop-area event-group-node",
      attrs: {
        "name": group.key
      }
    }, [_vm._l((group.events), function(event, eventKey) {
      return _c('div', {
        class: _vm.selectionClass(event.key, _vm.selectedEventId) + ' event-node',
        attrs: {
          "name": event.key
        }
      }, [(event.type === 'group') ? _c('i', {
        staticClass: "material-icons",
        staticStyle: {
          "width": "14px, height: 14px",
          "position": "relative",
          "vertical-align": "middle",
          "margin-top": "-3px"
        }
      }, [_vm._v("device_hub")]) : _vm._e(), _vm._v("\n                    " + _vm._s(event.name || 'untitled'))])
    }), _vm._v(" "), _c('div', {
      staticClass: " plus-button",
      on: {
        "click": function($event) {
          _vm.createEvent(group.key)
        }
      }
    }, [_vm._v("+")])], 2), _vm._v(" "), _c('div', {
      staticClass: "arrow-down"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "group-node event-drop-area collapsed"
  }, [_c('div', {
    staticClass: "plus-button",
    on: {
      "click": _vm.createEventAndGroup
    }
  }, [_vm._v("\n                +\n              ")])]), _vm._v(" "), _vm._m(0)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--6-col mdl-cell--12-col-tablet"
  }, [_c('div', {
    staticStyle: {
      "background-color": "white",
      "padding-left": "30px",
      "text-align": "left"
    }
  }, [_c('h5', {
    staticClass: "mdl-cell--12-col"
  }, [_vm._v("Edit Event")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedEventId),
      expression: "selectedEventId"
    }]
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col",
    class: {
      'is-dirty': _vm.selectedEvent.name
    }
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": _vm.selectedEvent.name
    },
    on: {
      "input": _vm.changeEventName
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v("Event Name...")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--12-col"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    attrs: {
      "id": "eventType",
      "name": "eventType"
    },
    on: {
      "change": _vm.changeEventType
    }
  }, [_c('option', {
    attrs: {
      "value": "action"
    },
    domProps: {
      "selected": _vm.selectedEvent.type === 'action'
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "group"
    },
    domProps: {
      "selected": _vm.selectedEvent.type === 'group'
    }
  }, [_vm._v("Group")])]), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "eventTypeLbl"
    }
  }, [_vm._v("Event Type")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('label', {
    class: ((_vm.selectedEvent.customText ? 'is-checked ' : '') + ' mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect '),
    attrs: {
      "for": "checkbox-1"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "type": "checkbox",
      "id": "checkbox-1"
    },
    domProps: {
      "checked": _vm.selectedEvent.customText,
      "value": _vm.selectedEvent.customText
    },
    on: {
      "change": _vm.changeEventCustomText
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Custom Text")])]), _vm._v(" "), (_vm.selectedEvent.type === 'action' && _vm.selectedEvent.customText) ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col",
    class: {
      'is-dirty': _vm.selectedEvent.text
    }
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": _vm.selectedEvent.text
    },
    on: {
      "input": _vm.changeEventText
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v("Custom text on success...")])]) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.type === 'action' && !_vm.selectedEvent.customText) ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col",
    class: {
      'is-dirty': _vm.selectedEvent.text
    }
  }, [_c('label', {
    staticClass: "mdl-label",
    staticStyle: {
      "font-style": "italic",
      "color": "#999"
    },
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v(_vm._s(_vm.getActionText() || 'No Text'))])]) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.type === 'action') ? _c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--6-col"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    class: {
      'is-none': _vm.selectedEvent.baseObj === ''
    },
    attrs: {
      "id": "objectType",
      "name": "objectType"
    },
    on: {
      "change": _vm.changeBaseObj
    }
  }, _vm._l((_vm.getObjects), function(object, objectKey) {
    return _c('option', {
      class: {
        'is-none': objectKey === ''
      },
      domProps: {
        "value": objectKey,
        "selected": _vm.selectedEvent.baseObj === objectKey
      }
    }, [_vm._v(_vm._s(object.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Base Object")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.type === 'action' && _vm.selectedEvent.baseObj) ? _c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--6-col"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    class: {
      'is-none': _vm.selectedEvent.targetObj === ''
    },
    attrs: {
      "id": "objectType",
      "name": "objectType"
    },
    on: {
      "change": _vm.changeTargetObj
    }
  }, _vm._l((_vm.getObjects), function(object, objectKey) {
    return _c('option', {
      class: {
        'is-none': objectKey === ''
      },
      domProps: {
        "value": objectKey,
        "selected": _vm.selectedEvent.targetObj === objectKey
      }
    }, [_vm._v(_vm._s(object.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Target Object (optional)")]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.type === 'action' && _vm.selectedEvent.baseObj) ? _c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--12-col"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    class: {
      'is-none': _vm.selectedEvent.resultInventoryObj === ''
    },
    attrs: {
      "id": "objectType",
      "name": "objectType"
    },
    on: {
      "change": _vm.changeResultInventoryObj
    }
  }, _vm._l((_vm.getObjects), function(object, objectKey) {
    return _c('option', {
      class: {
        'is-none': objectKey === ''
      },
      domProps: {
        "value": objectKey,
        "selected": _vm.selectedEvent.resultInventoryObj === objectKey
      }
    }, [_vm._v(_vm._s(object.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Result Inventory Object (optional)")]), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.type === 'action' && _vm.selectedEvent.baseObj) ? _c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label mdl-cell--12-col"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    class: {
      'is-none': _vm.selectedEvent.resultStageObj === ''
    },
    attrs: {
      "id": "objectType",
      "name": "objectType"
    },
    on: {
      "change": _vm.changeResultStageObj
    }
  }, _vm._l((_vm.getObjects), function(object, objectKey) {
    return _c('option', {
      class: {
        'is-none': objectKey === ''
      },
      domProps: {
        "value": objectKey,
        "selected": _vm.selectedEvent.resultStageObj === objectKey
      }
    }, [_vm._v(_vm._s(object.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Result Stage Object (optional)")]), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--12-col",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.selectedEvent.type === 'group') ? _c('router-link', {
    staticClass: "mdl-cell--6-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "to": ('/editor/' + _vm.adventureId + '/chapters/' + _vm.chapterId + '/timeline/' + _vm.selectedEventId)
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("device_hub")]), _vm._v(" Events")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "mdl-cell--6-col mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.removeEvent(_vm.selectedEventId)
      }
    }
  }, [_vm._v("\n                Remove")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.selectedEventId),
      expression: "!selectedEventId"
    }]
  }, [_vm._v("\n          No event selected.\n        ")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "arrow-up delimiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "delimiter-node"
  }, [_vm._v("END")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13a230f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionTimeline.vue
// module id = 302
// module chunks = 0